import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  addingToCart,
  addToCart as addToCartReducer,
  increaseQuantity as increaseQuantityReducer,
  decreaseQuantity as decreaseQuantityReducer,
  checkoutDeliveryOrder as checkoutDeliveryOrderReducer,
} from 'reducers/orders.reducer'
import { ordersService } from 'services/orders.service'
import IDeliveryOrder, {
  CartItem,
  IDeliveryOrderResponse,
} from 'models/IDeliveryOrder'

export const addToCart = (cartItem: CartItem) => (dispatch: Dispatch) => {
  try {
    dispatch(addingToCart())

    setTimeout(() => {
      dispatch(addToCartReducer({ cart: cartItem }))
    }, 200)
  } catch (error) {
    console.error(error)
  }
}

export const increaseQuantity =
  (productId: number, variantName: string | null) => (dispatch: Dispatch) => {
    try {
      dispatch(increaseQuantityReducer({ productId, variantName }))
    } catch (error) {
      console.error(error)
    }
  }

export const decreaseQuantity =
  (productId: number, variantName: string | null) => (dispatch: Dispatch) => {
    try {
      dispatch(decreaseQuantityReducer({ productId, variantName }))
    } catch (error) {
      console.error(error)
    }
  }

export const checkoutDeliveryOrder =
  (deliveryOrder: IDeliveryOrder) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await ordersService.checkoutOrder(deliveryOrder)
      if (response) {
        dispatch(
          checkoutDeliveryOrderReducer({
            data: response.data as IDeliveryOrderResponse,
          })
        )
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }
